import { PICBOOK_LOWER } from '@/router/const';

/**
 * 获取请求后端接口不同环境的域名
 */
export const getDomain = () => {
  if (isWoa) {
    if (isLocal) {
      return '//testdreamai.woa.com';
    }
    if (isTest) {
      return '//testdreamai.woa.com';
    }
    if (isProd) {
      return '//dreamai.woa.com';
    }
  }
  if (isLocal) {
    return '//t.api.dreamai.fun';
  }
  if (isTest) {
    return '//t.api.dreamai.fun';
  }
  return '//api.dreamai.fun';
};

/**
 * 前端不同环境域名
 * @returns
 */
export const getWebDomain = () => {
  if (isWoa) {
    if (isLocal) {
      return '//testdreamai.woa.com';
    }
    if (isTest) {
      return '//testdreamai.woa.com';
    }
    if (isProd) {
      return '//dreamai.woa.com';
    }
  }
  if (isLocal) {
    return '//test.dreamai.fun';
  }
  if (isTest) {
    return '//test.dreamai.fun';
  }
  return '//dreamai.fun';
};

export const getAuthPath = () => {
  if (isWoa) {
    return '/cms';
  }
  return '';
};

export const getImSDKAppId = () => {
  if (isLocal) {
    return 1600037445;
  }
  if (isTest) {
    return 1600037445;
  }
  return 1600032049;
};

export const homePageUrl = (env: 'prod' | 'test' | 'local') => {
  let domain = '//dreamai.fun';
  if (isWoa) {
    if (env === 'prod') {
      domain = '//dreamai.woa.com';
    } else if (env === 'test') {
      domain = '//testdreamai.woa.com';
    } else if (env === 'local') {
      domain = '//testdreamai.woa.com';
    }
  } else
    if (env === 'prod') {
      domain = '//dreamai.fun';
    } else if (env === 'test') {
      domain = '//test.dreamai.fun';
    } else if (env === 'local') {
      domain = '//test.dreamai.fun';
    }
  return `${domain}/`;
};

// 环境判断
export const isLocal = ((window.location.host.includes('test.dreamai.fun') || window.location.host.includes('testdreamai'))) && (process.env.NODE_ENV === 'local');
export const isTest = (window.location.host.includes('test.dreamai.fun') || window.location.host.includes('testdreamai'));
export const isProd = !isTest;

// 类型判断
export const isWoa = window.location.host.includes('.woa.com');
export const isUgc = window.location.host.includes('dreamai.fun');
export const isPic = window.location.pathname
  .toLowerCase().split('/')
  .includes(PICBOOK_LOWER);

export const ENV_NAME = {
  local: 'local',
  test: 'test',
  prod: 'production',
};

export const envCname = () => {
  if (isLocal) {
    return '开发环境';
  }
  if (isTest) {
    return '测试环境';
  }

  return '正式环境';
};

export const envName = () => {
  if (isLocal) {
    return ENV_NAME.local;
  }
  if (isTest) {
    return ENV_NAME.test;
  }
  return ENV_NAME.prod;
};

export const getLoginApi = () => {
  const APP_LOGIN_API = '//tpbaccess.video.qq.com'; // 测试
  const APP_LOGIN_API_PROD = '//pbaccess.video.qq.com';
  if (isLocal || isTest) {
    return APP_LOGIN_API;
  }
  return APP_LOGIN_API_PROD;
};
